import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from 'src/app/modules/shared/state/signal-entity.store';
import {FlowQuestion} from 'src/app/modules/shared/models/claim.model';

export interface ClaimsQuestionsState extends EntityState<FlowQuestion> { }

@Injectable({providedIn: 'root'})
export class ClaimsQuestionStore extends SignalEntityStore<FlowQuestion, ClaimsQuestionsState>{
    constructor(){
        super({name: 'claims-questions', idKey: 'cent_aq_question_id'});
    }

}
